import { Environment} from '../models/environment.model';

export class EnvironmentLoader {
    private static env: Environment = {} as Environment;
    public static async loadEnvironment(): Promise<void> {
        try {
            const response = await fetch('/assets/config.json');
            const json = await response.json();
            EnvironmentLoader.env = json;
        } catch (err) {
            console.warn('⚠️ Failed to load runtime environment config.', err);
        }
    }

    public static get environment(): Environment {
        return EnvironmentLoader.env;
    }
}
